import React, {useEffect} from 'react';
import DefaultLayout from './../layouts/DefaultLayout/DefaultLayout';
import './UsersFormPage.scss';
import {Container} from "react-bootstrap";
import usersAPI from "../../api/usersAPI";
import useAsyncData from "../../hooks/useAsyncData";
import UserCompleteForm from "../../components/UserCompleteForm/UserCompleteForm";
import {useHistory} from "react-router-dom";
import route from "../../helpers/route";
import {useSelector} from "react-redux";
import AsyncContent from "../../components/AsyncContent/AsyncContent";
import {
  getPlatforms,
  getPlatformRoles,
} from "../../store/actions/common";
import {connect} from "react-redux";

const UsersCreatePage = ({getPlatforms, getPlatformRoles}) => {
  const history = useHistory();

  const [onSubmitHandler, _, formLoading, formError] = useAsyncData(async ({setError}, values) => {
    try{
      await usersAPI.create(values);
      history.push(route('users'));
    }catch(e){
      if(e.response?.status === 422){
        setError('Algun campo es invalido');
      }else{
        setError('Error ');
      }
    }
  });

  const {platforms, platformRoles} = useSelector(state => state.common.extra);

  const [loadEntities, __, entitiesLoading, entitiesError] = useAsyncData(async ({setError, setLoading}) => {
    return Promise.all([
      getPlatforms(),
      getPlatformRoles(),
    ]).catch(err => setError('Error al cargar'));
  });

  useEffect(() => {
    if(platforms === null || platformRoles === null){
      loadEntities();
    }
  }, []);

  return (
    <DefaultLayout title="Creando usuario">
      <div className="UsersCreatePage">
        <div className="main-container">
          <Container fluid="xl" className="container--xs-full">
            <div className="page-card">
              <h2 className="page-card__title">
                Creando usuario
              </h2>
              <div className="page-card__content">
                <AsyncContent
                  hasError={!!entitiesError}
                  errorMessage={entitiesError}
                  isLoading={entitiesLoading}
                >
                  {!entitiesLoading && (
                    <UserCompleteForm
                      onSubmit={onSubmitHandler}
                      serverError={formError}
                      loading={formLoading}
                      submitLabel="Crear"
                      platforms={platforms}
                      platformRoles={platformRoles}
                    />
                  )}
                </AsyncContent>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </DefaultLayout>
  );
}

const mapDispatchToProps = {
  getPlatforms,
  getPlatformRoles,
}

UsersCreatePage.propTypes = {

};

export default connect(null, mapDispatchToProps)(UsersCreatePage);